import React, {Component} from 'react'
import NextItemsPage from "./NextItemsPage"
import { withRouter } from 'react-router-dom';
class NextItemsPageContainer extends Component {
    render() {
        const query = new URLSearchParams(this.props.location.search);
        const barcode = query.get("barcode");
        
        return (
            <div className="NextItemsPageContainer">
                <NextItemsPage barcode={barcode}/>
            </div>
        )
    }
}

export default withRouter(NextItemsPageContainer)
